/*
 *
 * PosGenericPopUp
 *
 * @version 1.0.0
 * @author Serafino Busalacchi
 * @since 03-Apr-2026
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { doPopup } from 'Store/actions/popup'
import { doGetSubscriptionGlobal } from 'Store/actions/user'
import { getPopupData } from 'Store/selectors'
import * as pointsOfSalesActions from 'Route/PointsOfSales/modules/PointsOfSalesActions'
import PosGenericPopUp from './PosGenericPopUp'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(pointsOfSalesActions, dispatch),
  doGetSubscriptionGlobal: bindActionCreators(doGetSubscriptionGlobal, dispatch),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  data: getPopupData(state),
  selectedPointOfSale: state?.PointsOfSales?.selectedPointOfSale || null,
  isLoading: state?.loading?.local_updatePointOfSale || state?.loading?.local_createOrUpdatePrivacyPolicy || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PosGenericPopUp)
